export type Service = {
  id: string
  title: string
  blurb: string
  icon:
    | 'layers'
    | 'home'
    | 'wrench'
    | 'hardhat'
    | 'hammer'
    | 'doorOpen'
    | 'trees'
    | 'bath'
  items: string[]
  image?: string
}

export const services: Service[] = [
  {
    id: 'flooring',
    title: 'Flooring Services',
    blurb: 'Durable, beautiful floors installed with a level subfloor underneath.',
    icon: 'layers',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ed7bc148-e562-4296-b7b6-d5dfc6840b99.jpg',
    items: [
      'Luxury vinyl plank (LVP) installation',
      'Hardwood floor installation and refinishing',
      'Tile and laminate flooring',
      'Carpet installation and removal',
      'Subfloor repairs and leveling'
    ]
  },
  {
    id: 'remodeling',
    title: 'Remodeling & Renovations',
    blurb: 'Full-scale transformations, managed start to finish by one crew.',
    icon: 'home',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/97bdf35e-f33d-44f6-971b-b43e358e9256.jpg',
    items: [
      'Kitchen and bathroom remodels',
      'Whole-home renovations',
      'Basement finishing and conversions'
    ]
  },
  {
    id: 'handyman',
    title: 'Handyman, Repair & Services',
    blurb: 'The small stuff that keeps a home running — handled in one visit.',
    icon: 'wrench',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/1e240742-e877-4cf5-983d-b2d653f62747.jpg',
    items: [
      'Drywall repair and installation',
      'Interior and exterior painting',
      'Minor plumbing and electrical fixes',
      'General home maintenance and odd jobs'
    ]
  },
  {
    id: 'structural',
    title: 'Structural & Foundation Work',
    blurb: 'Support and waterproofing that keeps everything above it solid.',
    icon: 'hardhat',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/c1b0125e-fdb5-4d9e-9639-aa058d84b0be.jpg',
    items: [
      'Foundation repairs, waterproofing, and reinforcements',
      'Concrete work and masonry',
      'Framing and structural enhancements'
    ]
  },
  {
    id: 'roofing',
    title: 'Roofing & Exterior Services',
    blurb: 'Built for Colorado hail, wind, and snow load.',
    icon: 'hammer',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/8fb733fe-28f6-4f67-92ad-b994e848deaf.jpg',
    items: [
      'Roof repair, replacement, and installation',
      'Siding and gutter installation',
      'Deck and patio construction'
    ]
  },
  {
    id: 'doors-windows',
    title: 'Doors & Windows',
    blurb: 'Tighter seals, lower bills, better curb appeal.',
    icon: 'doorOpen',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/b412151d-c313-48dc-9980-68c0dad351f9.jpg',
    items: [
      'Window replacements and upgrades',
      'Door installations and repairs',
      'Energy-efficient solutions'
    ]
  },
  {
    id: 'outdoor',
    title: 'Outdoor & Landscape',
    blurb: 'Usable outdoor space that drains and lasts.',
    icon: 'trees',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ac885f77-b4ef-47b8-a8fb-ab14584e362b.jpg',
    items: [
      'Landscape enhancements',
      'Fencing and retaining walls',
      'Pergolas and outdoor structures',
      'Drainage solutions'
    ]
  },
  {
    id: 're-glaze',
    title: 'Re-Glaze / Refinish',
    blurb: 'A like-new finish without the cost of a full tear-out.',
    icon: 'bath',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/9fa6e3ef-f384-4c89-aea8-04c1530fda4b.jpg',
    items: ['Bathtub resurfacing', 'Old tile resurfacing', 'Countertop resurfacing']
  }
]
